var map = {
	"./Affordable_Card.svg": 37010,
	"./Affordable_Card1.svg": 1715,
	"./Affordable_Card_Mobile.svg": 25777,
	"./CODIcon.svg": 38267,
	"./Easiness_Card.svg": 96287,
	"./Easiness_Card1.svg": 53152,
	"./Easiness_Card_Mobile.svg": 99989,
	"./Fast_Card.svg": 3817,
	"./Fast_Card1.svg": 87949,
	"./Fast_Card_Mobile.svg": 27001,
	"./Ill_Badge_Success.svg": 27033,
	"./Ill_badge_confirmation-general.svg": 47307,
	"./Ill_spot_email_verifikasi_expired.svg": 23416,
	"./Ill_spot_form_link.svg": 90531,
	"./Jagopack-homepage.svg": 4749,
	"./Jagopack_Landpack-Banner-Utama.svg": 5388,
	"./Jagopack_Landpack-Sub-Banner.svg": 90577,
	"./Liona.webp": 10853,
	"./POS_Card.svg": 37491,
	"./POS_Card1.svg": 14684,
	"./POS_Card_Mobile.svg": 21337,
	"./Rectangle.png": 31445,
	"./Reliable_Card.svg": 77128,
	"./Reliable_Card1.svg": 16127,
	"./Reliable_Card_Mobile.svg": 57238,
	"./UploadIcon.svg": 30570,
	"./Youtube.png": 65243,
	"./about-us/about-us-section-1_1.svg": 12765,
	"./about-us/about-us-section-1_2.svg": 75376,
	"./about-us/about-us-section-2_1.svg": 98847,
	"./about-us/about-us-section-2_2.svg": 30025,
	"./about-us/about-us-section-2_3.svg": 12646,
	"./about-us/about-us-section-2_4.svg": 92131,
	"./about/2021reward1.webp": 57660,
	"./about/2021reward1_mobile.svg": 69942,
	"./about/2021reward1_mobile.webp": 35877,
	"./about/2021reward1_mobile_thumb.svg": 60233,
	"./about/2021reward1_mobile_thumb.webp": 90529,
	"./about/2021reward1_thumb.webp": 69250,
	"./about/2021reward2.webp": 98524,
	"./about/2021reward2_mobile.svg": 10818,
	"./about/2021reward2_mobile.webp": 29749,
	"./about/2021reward2_mobile_thumb.svg": 68881,
	"./about/2021reward2_mobile_thumb.webp": 95694,
	"./about/2021reward2_thumb.webp": 52419,
	"./about/2021reward3.webp": 97252,
	"./about/2021reward3_mobile.svg": 40032,
	"./about/2021reward3_mobile.webp": 8936,
	"./about/2021reward3_mobile_thumb.svg": 35846,
	"./about/2021reward3_mobile_thumb.webp": 5097,
	"./about/2021reward3_thumb.webp": 29930,
	"./about/2022reward1.webp": 15762,
	"./about/2022reward1_mobile.svg": 17691,
	"./about/2022reward1_mobile.webp": 2911,
	"./about/2022reward1_mobile_thumb.svg": 33431,
	"./about/2022reward1_mobile_thumb.webp": 50624,
	"./about/2022reward1_thumb.webp": 26848,
	"./about/2022reward2.webp": 17958,
	"./about/2022reward2_mobile.svg": 84291,
	"./about/2022reward2_mobile.webp": 21358,
	"./about/2022reward2_mobile_thumb.svg": 25957,
	"./about/2022reward2_mobile_thumb.webp": 79236,
	"./about/2022reward2_thumb.webp": 75592,
	"./about/2022reward3.webp": 50928,
	"./about/2022reward3_mobile.svg": 88727,
	"./about/2022reward3_mobile.webp": 17545,
	"./about/2022reward3_mobile_thumb.svg": 8268,
	"./about/2022reward3_mobile_thumb.webp": 51629,
	"./about/2022reward3_thumb.webp": 83218,
	"./about/2022reward4.webp": 47737,
	"./about/2022reward4_mobile.svg": 77662,
	"./about/2022reward4_mobile.webp": 83696,
	"./about/2022reward4_mobile_thumb.svg": 68496,
	"./about/2022reward4_mobile_thumb.webp": 69105,
	"./about/2022reward4_thumb.webp": 1157,
	"./about/2022reward5.webp": 98810,
	"./about/2022reward5_mobile.svg": 9341,
	"./about/2022reward5_mobile.webp": 36762,
	"./about/2022reward5_mobile_thumb.svg": 84606,
	"./about/2022reward5_mobile_thumb.webp": 6216,
	"./about/2022reward5_thumb.webp": 93172,
	"./about/2022reward6.webp": 52657,
	"./about/2022reward6_mobile.svg": 4754,
	"./about/2022reward6_mobile.webp": 80818,
	"./about/2022reward6_mobile_thumb.svg": 1421,
	"./about/2022reward6_mobile_thumb.webp": 22571,
	"./about/2022reward6_thumb.webp": 22709,
	"./about/2022reward7.webp": 59361,
	"./about/2022reward7_mobile.svg": 73328,
	"./about/2022reward7_mobile.webp": 24469,
	"./about/2022reward7_mobile_thumb.svg": 73860,
	"./about/2022reward7_mobile_thumb.webp": 72338,
	"./about/2022reward7_thumb.webp": 64875,
	"./about/2022reward8.webp": 74454,
	"./about/2022reward8_mobile.svg": 59754,
	"./about/2022reward8_mobile.webp": 13368,
	"./about/2022reward8_mobile_thumb.svg": 34458,
	"./about/2022reward8_mobile_thumb.webp": 80366,
	"./about/2022reward8_thumb.webp": 21544,
	"./about/2023reward1.webp": 94818,
	"./about/2023reward10.webp": 66813,
	"./about/2023reward10_mobile.webp": 32596,
	"./about/2023reward10_mobile_thumb.svg": 12228,
	"./about/2023reward10_thumb.webp": 85487,
	"./about/2023reward11.webp": 7119,
	"./about/2023reward11_mobile.webp": 67281,
	"./about/2023reward11_mobile_thumb.svg": 34812,
	"./about/2023reward11_thumb.webp": 86263,
	"./about/2023reward12.webp": 24737,
	"./about/2023reward12_mobile.webp": 55833,
	"./about/2023reward12_mobile_thumb.svg": 23195,
	"./about/2023reward12_thumb.webp": 30351,
	"./about/2023reward13.webp": 74214,
	"./about/2023reward13_mobile.webp": 7651,
	"./about/2023reward13_mobile_thumb.svg": 79985,
	"./about/2023reward13_thumb.webp": 49307,
	"./about/2023reward14.webp": 81418,
	"./about/2023reward14_mobile.webp": 98439,
	"./about/2023reward14_mobile_thumb.svg": 92156,
	"./about/2023reward14_thumb.webp": 79846,
	"./about/2023reward15.webp": 89178,
	"./about/2023reward15_mobile.webp": 56792,
	"./about/2023reward15_mobile_thumb.svg": 46124,
	"./about/2023reward15_thumb.webp": 35130,
	"./about/2023reward1_mobile.svg": 91902,
	"./about/2023reward1_mobile.webp": 68152,
	"./about/2023reward1_mobile_thumb.svg": 83828,
	"./about/2023reward1_mobile_thumb.webp": 91250,
	"./about/2023reward1_thumb.webp": 30669,
	"./about/2023reward2.webp": 60332,
	"./about/2023reward2_mobile.svg": 34830,
	"./about/2023reward2_mobile.webp": 59320,
	"./about/2023reward2_mobile_thumb.svg": 18113,
	"./about/2023reward2_mobile_thumb.webp": 32689,
	"./about/2023reward2_thumb.webp": 10398,
	"./about/2023reward3.webp": 44310,
	"./about/2023reward3_mobile.svg": 70358,
	"./about/2023reward3_mobile.webp": 64425,
	"./about/2023reward3_mobile_thumb.svg": 75968,
	"./about/2023reward3_mobile_thumb.webp": 38565,
	"./about/2023reward3_thumb.webp": 57935,
	"./about/2023reward4.webp": 1843,
	"./about/2023reward4_mobile.svg": 45924,
	"./about/2023reward4_mobile.webp": 65270,
	"./about/2023reward4_mobile_thumb.svg": 70007,
	"./about/2023reward4_mobile_thumb.webp": 82299,
	"./about/2023reward4_thumb.webp": 76101,
	"./about/2023reward5.webp": 57791,
	"./about/2023reward5_mobile.svg": 47754,
	"./about/2023reward5_mobile.webp": 28204,
	"./about/2023reward5_mobile_thumb.svg": 34829,
	"./about/2023reward5_mobile_thumb.webp": 88993,
	"./about/2023reward5_thumb.webp": 67084,
	"./about/2023reward6.webp": 35577,
	"./about/2023reward6_mobile.svg": 3403,
	"./about/2023reward6_mobile.webp": 94349,
	"./about/2023reward6_mobile_thumb.svg": 94286,
	"./about/2023reward6_mobile_thumb.webp": 84703,
	"./about/2023reward6_thumb.webp": 94450,
	"./about/2023reward7.webp": 80645,
	"./about/2023reward7_mobile.svg": 69220,
	"./about/2023reward7_mobile.webp": 25240,
	"./about/2023reward7_mobile_thumb.svg": 53344,
	"./about/2023reward7_mobile_thumb.webp": 69744,
	"./about/2023reward7_thumb.webp": 69249,
	"./about/2023reward8.webp": 63319,
	"./about/2023reward8_mobile.svg": 47560,
	"./about/2023reward8_mobile.webp": 9635,
	"./about/2023reward8_mobile_thumb.svg": 93941,
	"./about/2023reward8_mobile_thumb.webp": 30704,
	"./about/2023reward8_thumb.webp": 21374,
	"./about/2023reward9.webp": 31222,
	"./about/2023reward9_mobile.svg": 21770,
	"./about/2023reward9_mobile.webp": 23317,
	"./about/2023reward9_mobile_thumb.svg": 49084,
	"./about/2023reward9_mobile_thumb.webp": 90149,
	"./about/2023reward9_thumb.webp": 46092,
	"./about/2024reward1.webp": 12999,
	"./about/2024reward1_mobile.webp": 48541,
	"./about/2024reward1_mobile_thumb.webp": 4719,
	"./about/2024reward1_thumb.webp": 91769,
	"./about/2024reward2.webp": 20480,
	"./about/2024reward2_mobile.webp": 56300,
	"./about/2024reward2_mobile_thumb.webp": 96387,
	"./about/2024reward2_thumb.webp": 1342,
	"./about/2024reward3.webp": 94449,
	"./about/2024reward3_mobile.webp": 58784,
	"./about/2024reward3_mobile_thumb.webp": 81512,
	"./about/2024reward3_thumb.webp": 28625,
	"./about/2024reward4.webp": 36985,
	"./about/2024reward4_mobile.webp": 41700,
	"./about/2024reward4_mobile_thumb.webp": 66771,
	"./about/2024reward4_thumb.webp": 55218,
	"./about/2024reward5.webp": 14576,
	"./about/2024reward5_mobile.webp": 81578,
	"./about/2024reward5_mobile_thumb.webp": 73124,
	"./about/2024reward5_thumb.webp": 32874,
	"./about/2024reward6.webp": 63866,
	"./about/2024reward6_mobile.webp": 79536,
	"./about/2024reward6_mobile_thumb.webp": 48445,
	"./about/2024reward6_thumb.webp": 85196,
	"./about/2024reward7.webp": 68198,
	"./about/2024reward7_mobile.webp": 31159,
	"./about/2024reward7_mobile_thumb.webp": 36758,
	"./about/2024reward7_thumb.webp": 50822,
	"./about/2024reward8.webp": 4893,
	"./about/2024reward8_mobile.webp": 88330,
	"./about/2024reward8_mobile_thumb.webp": 42226,
	"./about/2024reward8_thumb.webp": 83633,
	"./about/2024reward9.webp": 14403,
	"./about/2024reward9_mobile.webp": 97075,
	"./about/2024reward9_mobile_thumb.webp": 1617,
	"./about/2024reward9_thumb.webp": 48303,
	"./about/adwina.webp": 45119,
	"./about/andika.webp": 99588,
	"./about/arif.webp": 63669,
	"./about/bg_about_us.webp": 55651,
	"./about/bg_about_us_mobile.webp": 92603,
	"./about/blank.webp": 59678,
	"./about/board-adwina.webp": 6706,
	"./about/board-andika.webp": 58434,
	"./about/board-arif.webp": 43947,
	"./about/board-blank.webp": 58384,
	"./about/board-budi.webp": 39766,
	"./about/board-fadli.webp": 33748,
	"./about/board-farian.webp": 66691,
	"./about/board-kenny.webp": 58389,
	"./about/board-mobile-adwina.webp": 29297,
	"./about/board-mobile-andika.webp": 21211,
	"./about/board-mobile-arif.webp": 50359,
	"./about/board-mobile-blank.webp": 48492,
	"./about/board-mobile-budi.webp": 69499,
	"./about/board-mobile-fadli.webp": 33036,
	"./about/board-mobile-farian.webp": 79374,
	"./about/board-mobile-kenny.webp": 3935,
	"./about/board-mobile-victor.webp": 19991,
	"./about/board-victor.webp": 21357,
	"./about/budi.webp": 51012,
	"./about/collab-ico.svg": 77927,
	"./about/collab.webp": 36328,
	"./about/cup.svg": 42331,
	"./about/fadli.webp": 10246,
	"./about/farian.webp": 22091,
	"./about/honest-ico.svg": 49606,
	"./about/honest.webp": 60799,
	"./about/ill_tentang_kami.svg": 7471,
	"./about/kenny.webp": 24011,
	"./about/line.png": 61886,
	"./about/old_bg_about_us_mobile.svg": 48561,
	"./about/plus.svg": 68374,
	"./about/rise-ico.svg": 50699,
	"./about/rise.webp": 22399,
	"./about/stand-lion-parcel.webp": 15035,
	"./about/trust-ico.svg": 23451,
	"./about/trust.webp": 1408,
	"./about/victor.webp": 27454,
	"./about_us.svg": 7717,
	"./account.svg": 33909,
	"./account/ics_o_location_pin.svg": 72080,
	"./account/ics_o_profile.svg": 82567,
	"./account_banner_desktop.svg": 28202,
	"./add_oleholeh.svg": 92495,
	"./agent-location/Lokasi_POS.webp": 22464,
	"./agent-location/Lokasi_POS_mobile.webp": 86106,
	"./agent-location/cta_pos_interpack.webp": 79176,
	"./agent-location/cta_pos_interpack_long.webp": 2815,
	"./agent-location/cta_pos_interpack_mobile.webp": 44406,
	"./agent/agent_office_1.webp": 38800,
	"./agent/agent_office_2.webp": 73573,
	"./agent/agent_story_1.webp": 93917,
	"./agent/agent_story_2.webp": 94407,
	"./agent/agent_story_3.webp": 42391,
	"./agent/agent_story_4.webp": 60291,
	"./agent/company_business.svg": 86529,
	"./agent/footer.webp": 54742,
	"./agent/footer_mobile.webp": 65305,
	"./agent/header.webp": 17980,
	"./agent/header_mobile.webp": 34440,
	"./agent/icon_telphone.svg": 68223,
	"./agent/ics_f_helpdesk.svg": 12993,
	"./agent/ics_f_love.svg": 37005,
	"./agent/ics_f_maps.svg": 43531,
	"./agent/ics_f_payment.svg": 58559,
	"./agent/ics_f_storeFavorite.svg": 88392,
	"./agent/ill_agen.svg": 60370,
	"./agent/informasi_map.svg": 15143,
	"./agent/informasi_map_sm.svg": 36709,
	"./agent/personal_business.svg": 64092,
	"./agent/register-individual-banner-mobile.svg": 39550,
	"./agent_banner.png": 89106,
	"./agent_banner_mobile.png": 77226,
	"./aggregator/banner_everpro.webp": 9862,
	"./aggregator/banner_everpro_mobile.webp": 40461,
	"./aggregator/banner_lincah.webp": 50027,
	"./aggregator/banner_lincah_mobile.webp": 44384,
	"./aggregator/banner_mengantar.webp": 1912,
	"./aggregator/banner_mengantar_mobile.webp": 74477,
	"./aggregator/bg_desktop.webp": 44883,
	"./aggregator/bg_mobile.webp": 43333,
	"./aggregator/rank1.svg": 49951,
	"./aggregator/rank10.svg": 4535,
	"./aggregator/rank2.svg": 54849,
	"./aggregator/rank3.svg": 29020,
	"./aggregator/rank4.svg": 27768,
	"./aggregator/rank5.svg": 81531,
	"./aggregator/rank6.svg": 23820,
	"./aggregator/rank7.svg": 56520,
	"./aggregator/rank8.svg": 39797,
	"./aggregator/rank9.svg": 72173,
	"./airplane.png": 55438,
	"./airplane_blue.png": 35510,
	"./aosd_card.svg": 50813,
	"./appStore.svg": 78978,
	"./appstore-plain.svg": 68730,
	"./appstore.png": 67114,
	"./appstore.webp": 24116,
	"./arrow-down.svg": 34127,
	"./arrow-promo-icon.svg": 33587,
	"./arrow-right-red.svg": 87425,
	"./arrow-stepper.svg": 8500,
	"./arrow_diagonal.svg": 59514,
	"./arrow_down_navbar.svg": 29065,
	"./arrow_right.svg": 87325,
	"./attach.png": 12792,
	"./balance_icon.svg": 88201,
	"./banner_bbi.jpg": 13316,
	"./banner_bbi_mobile.jpg": 26382,
	"./banner_candidate - Copy.png": 90912,
	"./banner_candidate.png": 47860,
	"./banner_candidate_mobile.png": 20254,
	"./banner_career.png": 3737,
	"./banner_career_mobile.png": 47275,
	"./banner_faq.png": 73408,
	"./banner_faq_mobile.png": 88790,
	"./banner_one.png": 96620,
	"./banner_product.svg": 19034,
	"./banner_product_mobile.svg": 50931,
	"./banner_saldo_point_content.svg": 99839,
	"./banner_three.png": 29999,
	"./banner_two.png": 11036,
	"./beta.svg": 17524,
	"./bg_after_payment.svg": 18853,
	"./bg_business_desktop.png": 78173,
	"./bg_business_mobile.png": 74426,
	"./bg_check_price_not_found.png": 59043,
	"./bg_claim_mobile.png": 86114,
	"./bg_cloud_mobile.png": 58508,
	"./bg_crop_second.png": 32740,
	"./bg_detail_check_price.png": 89857,
	"./bg_detail_check_price_mobile.png": 6901,
	"./bg_detail_claim.png": 1491,
	"./bg_detail_program.png": 34929,
	"./bg_detail_program_mobile.png": 38151,
	"./bg_form_merchant_mobile.svg": 63749,
	"./bg_head_dangerous.svg": 9506,
	"./bg_head_dangerous_mobile.svg": 83243,
	"./bg_home_mobile.png": 38762,
	"./bg_image_atas-svg.svg": 19389,
	"./bg_image_atas.svg": 91301,
	"./bg_image_bawah-svg.svg": 15664,
	"./bg_image_bawah.svg": 79570,
	"./bg_landing_page.svg": 92540,
	"./bg_mobile_new_claim.png": 74372,
	"./bg_our_service.svg": 20237,
	"./bg_track_shipment.png": 15702,
	"./bg_track_shipment_mobile.png": 23855,
	"./bg_web_oleholeh.svg": 68267,
	"./bg_web_oleholeh_2.png": 46248,
	"./bigpack.png": 12524,
	"./book_pen.png": 69305,
	"./bottom_cloud.png": 96885,
	"./box_cancel.png": 17440,
	"./box_not_found.png": 80213,
	"./bubble_question.png": 5883,
	"./building.svg": 86641,
	"./calender.svg": 53604,
	"./captcha-images/captcha_blank.svg": 66229,
	"./car_blue.png": 90660,
	"./card.png": 73618,
	"./card_promo_landpack.png": 18472,
	"./card_promo_onepack.png": 51350,
	"./card_promo_pas_jagopack.png": 38063,
	"./card_promo_regpack.png": 70496,
	"./cardboard_blue.png": 37089,
	"./cardboard_gray.png": 62344,
	"./career/Anton.webp": 12826,
	"./career/Ifo.webp": 83450,
	"./career/Ivo.webp": 96332,
	"./career/Okto.webp": 28357,
	"./career/Viqi.webp": 643,
	"./career/banner_career.webp": 15248,
	"./career/banner_career_job.webp": 88208,
	"./career/banner_career_job_mobile.webp": 33276,
	"./career/banner_career_mobile.webp": 98519,
	"./career/career_company_value_line.svg": 49855,
	"./career/career_cta_desktop.webp": 10380,
	"./career/career_cta_mobile.webp": 99058,
	"./career/employee1.webp": 81778,
	"./career/event1.webp": 76040,
	"./career/event2.webp": 24327,
	"./career/event3.webp": 89344,
	"./career/trustheteam-dekstop.webp": 39327,
	"./career/trustheteam-mobile.webp": 77898,
	"./cares_icon.svg": 72120,
	"./chat_three_dot.png": 32677,
	"./check-circle-red.svg": 89587,
	"./check_circle": 90427,
	"./check_circle.svg": 39785,
	"./check_circle.vue": 90427,
	"./check_price_not_found.png": 5479,
	"./checklist_blue.png": 14795,
	"./checklist_circle.svg": 48688,
	"./checklist_gray.png": 91461,
	"./checklist_green copy.png": 92460,
	"./checklist_green.png": 16768,
	"./checkmark.png": 40711,
	"./chevron-double-left.svg": 91614,
	"./chevron-double-right.svg": 43133,
	"./chevron-left.svg": 95742,
	"./chevron-right.svg": 71994,
	"./chevronIcon": 11458,
	"./chevronIcon.vue": 11458,
	"./chevron_down.svg": 89794,
	"./chevron_down_red.svg": 82300,
	"./chevron_left.png": 67262,
	"./chevron_left_black.png": 3331,
	"./chevron_left_red.svg": 11880,
	"./chevron_pagination.svg": 4855,
	"./chevron_right_black.png": 15174,
	"./chevron_right_gray.svg": 29564,
	"./chevron_right_red.svg": 77895,
	"./chevron_up.svg": 15372,
	"./claim/banner.png": 90668,
	"./claim/banner_mobile.png": 68437,
	"./claim/ill_ajukan_klaim_success.svg": 99211,
	"./claim_not_found.png": 66889,
	"./claim_success.png": 71065,
	"./client-1.jpg": 15326,
	"./client-10.jpg": 79379,
	"./client-11.jpg": 10910,
	"./client-2.jpg": 81032,
	"./client-3.jpg": 5718,
	"./client-4.jpg": 12304,
	"./client-5.jpg": 44488,
	"./client-6.jpg": 5284,
	"./client-7.jpg": 28452,
	"./client-8.jpg": 52605,
	"./client-9.jpg": 67721,
	"./clock.png": 78079,
	"./close.png": 63754,
	"./close_modal.png": 4721,
	"./close_modal.svg": 51091,
	"./close_rounded.svg": 33941,
	"./closetrack.svg": 2725,
	"./cloud.png": 84264,
	"./cloud_not_found.png": 48486,
	"./cloud_products.svg": 89217,
	"./cloud_products_mobile.svg": 35410,
	"./cod/antar-paketcod-desktop.webp": 82244,
	"./cod/antar-paketcod-m.svg": 61445,
	"./cod/banner.webp": 2699,
	"./cod/banner_mobile.webp": 66238,
	"./cod/bayar-cod-desktop.webp": 66882,
	"./cod/bayar-cod-m.svg": 10369,
	"./cod/cod-desktop.webp": 47757,
	"./cod/cod-m.svg": 3408,
	"./cod/diantarkan-kurir-desktop.webp": 81806,
	"./cod/diantarkan-kurir-m.svg": 75736,
	"./cod/ics_f_chat_question.svg": 81136,
	"./cod/ics_f_check_circle.svg": 64325,
	"./cod/ics_f_conversation.svg": 85043,
	"./cod/ics_f_creditcard.svg": 44580,
	"./cod/ics_f_grid.svg": 64024,
	"./cod/ics_f_insurance.svg": 9942,
	"./cod/ics_f_maps.svg": 47346,
	"./cod/ics_f_money.svg": 94823,
	"./cod/ics_f_money_alt.svg": 76125,
	"./cod/ics_f_payment.svg": 33314,
	"./cod/ics_f_price_tag.svg": 50463,
	"./cod/ics_f_retur.svg": 8085,
	"./cod/ics_f_star.svg": 22136,
	"./cod/ics_o_chevron_right.svg": 21645,
	"./cod/ill_badge_COD.svg": 5717,
	"./cod/ill_badge_DFOD.svg": 74290,
	"./cod/pickup-desktop.webp": 70966,
	"./cod/pickup-m.svg": 18146,
	"./cod/pilih-layanan-cod-desktop.webp": 36830,
	"./cod/pilih-layanan-cod-m.svg": 10326,
	"./collab_icon.svg": 45159,
	"./coming-soon.webp": 81481,
	"./complete-registration.svg": 70894,
	"./confirm.svg": 21565,
	"./confirm_illustration.svg": 27592,
	"./copy-shareit.png": 82065,
	"./copy_icon.svg": 83506,
	"./corporation/berrybenka.png": 46338,
	"./corporation/bukalapak.png": 79688,
	"./corporation/discount.svg": 20456,
	"./corporation/email.svg": 82975,
	"./corporation/footer-mobile.webp": 16669,
	"./corporation/footer.webp": 45810,
	"./corporation/form_corporation_banner_mobile.svg": 81016,
	"./corporation/header-mobile.webp": 84161,
	"./corporation/header.webp": 30821,
	"./corporation/hijup.png": 15023,
	"./corporation/ics_f_clipboard.svg": 74165,
	"./corporation/ics_f_file.svg": 15354,
	"./corporation/ics_f_task_check.svg": 62097,
	"./corporation/operational.svg": 9710,
	"./corporation/pickup.svg": 96801,
	"./corporation/riamiranda.png": 18244,
	"./corporation/saldo.svg": 41098,
	"./corporation/search-location.svg": 68204,
	"./corporation/tracking.svg": 1657,
	"./corporation/warehouse.svg": 69376,
	"./country/indonesia.svg": 25705,
	"./country/malaysia.svg": 55593,
	"./courier.png": 82985,
	"./css/animation.scss": 69832,
	"./css/calculate.scss": 68366,
	"./css/feature/style.scss": 61511,
	"./css/flexbox.scss": 73140,
	"./css/input.scss": 78805,
	"./css/reset.scss": 64874,
	"./css/spacing.scss": 11581,
	"./css/style.scss": 61302,
	"./cta-bg-mobile.svg": 79076,
	"./cta-bg.svg": 69453,
	"./daftar-pos-360.png": 61487,
	"./daftar-pos.png": 81809,
	"./dangerous_goods/ics_f_battery_full.svg": 36933,
	"./dangerous_goods/ics_f_cassette.svg": 23071,
	"./dangerous_goods/ics_f_cpu.svg": 64990,
	"./dangerous_goods/ics_f_flame.svg": 3559,
	"./dangerous_goods/ics_f_forbidden.svg": 38182,
	"./dangerous_goods/ics_f_gas_station.svg": 666,
	"./dangerous_goods/ics_f_paint_bucket.svg": 38526,
	"./dangerous_goods/ics_f_shield check.svg": 44283,
	"./dangerous_goods/ics_f_warning_square.svg": 37081,
	"./dangerous_goods/ics_f_warning_triangles.svg": 49291,
	"./dangerous_goods/ill_dangerous_goods.svg": 87470,
	"./dangerous_goods/ill_dangerous_goods_mobile.svg": 45628,
	"./date-icon.svg": 38664,
	"./default-banner-desktop-new.webp": 89588,
	"./default-banner-mobile-new.webp": 70811,
	"./default-banner-sm.svg": 32120,
	"./default-banner-xl.svg": 12175,
	"./detail.jpg": 6002,
	"./docupack.png": 33167,
	"./download.png": 29611,
	"./download_app_product.png": 77554,
	"./download_document.png": 56267,
	"./dropdown_bottom.png": 24604,
	"./dropdown_right.png": 30153,
	"./dropdown_top.png": 28298,
	"./eclipse-divider.svg": 56078,
	"./ellipse.png": 92707,
	"./email_verification_failed.svg": 48856,
	"./email_verification_success.svg": 73972,
	"./event-tips-example.svg": 47777,
	"./eventandtips/banner_desktop_blog.webp": 51662,
	"./eventandtips/banner_desktop_mitra.webp": 55278,
	"./eventandtips/banner_desktop_seller.webp": 49144,
	"./eventandtips/banner_mobile_blog.webp": 91755,
	"./eventandtips/banner_mobile_mitra.webp": 60309,
	"./eventandtips/banner_mobile_seller.webp": 65833,
	"./eventandtips/search-icon.svg": 35228,
	"./example_captcha.png": 37558,
	"./example_result_claim.png": 20223,
	"./example_result_claim_mobile.png": 65100,
	"./exclamation-circle-solid.svg": 7586,
	"./eye.svg": 29279,
	"./failed-register.svg": 83108,
	"./failed_illustration.svg": 72753,
	"./faq/apps/akun.svg": 27935,
	"./faq/apps/bisabelanja.svg": 34486,
	"./faq/apps/cek.svg": 36572,
	"./faq/apps/drop.svg": 92734,
	"./faq/apps/klaim.svg": 99983,
	"./faq/apps/member.svg": 39612,
	"./faq/apps/paketmu.svg": 71371,
	"./faq/apps/pembayaran.svg": 53086,
	"./faq/apps/pick.svg": 58148,
	"./faq/apps/poin.svg": 8869,
	"./faq/banner.svg": 78844,
	"./faq/banner_faq.webp": 28031,
	"./faq/banner_faq_mobile.webp": 48113,
	"./faq/banner_liona.webp": 22395,
	"./faq/banner_liona_mobile.webp": 43910,
	"./faq/banner_mobile.svg": 68190,
	"./faq/bantuan/agen.svg": 87700,
	"./faq/bantuan/asuransi.svg": 74167,
	"./faq/bantuan/bayar.svg": 95760,
	"./faq/bantuan/bisabelanja.svg": 8760,
	"./faq/bantuan/cod.svg": 12104,
	"./faq/bantuan/dangerous.svg": 53613,
	"./faq/bantuan/hitung.svg": 47274,
	"./faq/bantuan/kemas.svg": 8394,
	"./faq/bantuan/kirim.svg": 33795,
	"./faq/bantuan/klaim.svg": 40266,
	"./faq/bantuan/korporasi.svg": 44995,
	"./faq/bantuan/produk.svg": 30134,
	"./faq/ics_f_nearby_shuttle_alt.svg": 73404,
	"./faq/ics_f_payment.svg": 2335,
	"./faq/ics_f_posFavorite.svg": 99528,
	"./faq/ics_f_rocket.svg": 59103,
	"./faq/ics_f_shield check.svg": 80465,
	"./faq/ics_f_warning_triangles.svg": 46177,
	"./faq/notfound.svg": 94350,
	"./fb.png": 73869,
	"./feedback_bg.png": 25530,
	"./floating_icon_feedback.png": 9549,
	"./floating_icon_feedback.svg": 92272,
	"./footer_address.svg": 11605,
	"./footer_chat.svg": 13471,
	"./footer_clock.svg": 83107,
	"./footer_mail.svg": 71975,
	"./footer_message.svg": 50010,
	"./game/back-card.png": 70469,
	"./game/background-card.png": 6686,
	"./game/background-introduction.png": 3247,
	"./game/background-play.png": 65371,
	"./game/background-spin.png": 54909,
	"./game/box_confetti.svg": 69861,
	"./game/chevron-down.svg": 45711,
	"./game/confetti": 51557,
	"./game/confetti.json": 51557,
	"./game/counter-background.svg": 72270,
	"./game/error.svg": 22012,
	"./game/gold-card-bg.png": 34252,
	"./game/gold-card.png": 83224,
	"./game/gold.jpg": 93809,
	"./game/hologram-card-bg.png": 56850,
	"./game/hologram-card.png": 29355,
	"./game/hologram.jpg": 39154,
	"./game/ics_f_diamond.svg": 26828,
	"./game/ics_o_close.svg": 14230,
	"./game/introduction-box.png": 58878,
	"./game/logolp.svg": 46851,
	"./game/share_gold.jpg": 48452,
	"./game/share_hologram.jpg": 41424,
	"./game/share_silver_01.jpg": 84317,
	"./game/share_silver_02.jpg": 57688,
	"./game/share_silver_03.jpg": 37993,
	"./game/share_silver_04.jpg": 27178,
	"./game/share_silver_05.jpg": 44064,
	"./game/share_silver_06.jpg": 10093,
	"./game/share_silver_07.jpg": 8031,
	"./game/share_silver_08.jpg": 82869,
	"./game/share_silver_09.jpg": 34553,
	"./game/share_silver_10.jpg": 29736,
	"./game/shuffle.mp3": 97301,
	"./game/silver_01.jpg": 49056,
	"./game/silver_02.jpg": 12186,
	"./game/silver_03.jpg": 5808,
	"./game/silver_04.jpg": 4788,
	"./game/silver_05.jpg": 60382,
	"./game/silver_06.jpg": 99472,
	"./game/silver_07.jpg": 17954,
	"./game/silver_08.jpg": 62430,
	"./game/silver_09.jpg": 69791,
	"./game/silver_10.jpg": 1014,
	"./game/stackedimages.png": 94918,
	"./game/win.mp3": 94689,
	"./green_leaf.png": 13438,
	"./grow_icon.svg": 8586,
	"./happy_emot.svg": 31402,
	"./headphone.svg": 98949,
	"./home.png": 47589,
	"./home/email.webp": 97019,
	"./home/email_mobile.webp": 7633,
	"./home/right.svg": 43031,
	"./home/right_mobile.svg": 61600,
	"./home/success.svg": 91989,
	"./ic_cod.svg": 50848,
	"./icon-add.svg": 6561,
	"./icon-airplane.png": 42417,
	"./icon-close.svg": 48904,
	"./icon_airplane.png": 12330,
	"./icon_arrow_left.svg": 41023,
	"./icon_bigpack.svg": 52102,
	"./icon_car.png": 97043,
	"./icon_close.svg": 9431,
	"./icon_confirmation.svg": 47337,
	"./icon_danger_triangles.svg": 93013,
	"./icon_docupack.svg": 3745,
	"./icon_eight.png": 57150,
	"./icon_eighteen.svg": 10681,
	"./icon_eleven.png": 79632,
	"./icon_five.png": 14004,
	"./icon_fiveteen.svg": 25080,
	"./icon_four.png": 88526,
	"./icon_fourteen.png": 69566,
	"./icon_home.png": 15173,
	"./icon_interpack.png": 55017,
	"./icon_landpack.png": 17878,
	"./icon_login.svg": 46694,
	"./icon_logout.svg": 57440,
	"./icon_nine.png": 51618,
	"./icon_one.png": 68103,
	"./icon_onepack.svg": 83226,
	"./icon_referral-program.svg": 43961,
	"./icon_regpack.png": 9391,
	"./icon_search.png": 17644,
	"./icon_search.svg": 35942,
	"./icon_seven.png": 44410,
	"./icon_seventeen.svg": 40835,
	"./icon_six.png": 11922,
	"./icon_sixteen.svg": 25078,
	"./icon_telphone.svg": 35899,
	"./icon_ten.png": 17118,
	"./icon_thirteen.png": 90907,
	"./icon_three.png": 93111,
	"./icon_twelve.png": 48624,
	"./icon_two.png": 13045,
	"./ics_clock": 31461,
	"./ics_clock.vue": 31461,
	"./ics_f_check_circle.svg": 60388,
	"./ics_f_cherry.svg": 28086,
	"./ics_f_close_circle.svg": 54957,
	"./ics_f_close_circle_red.svg": 21875,
	"./ics_f_copy.svg": 20328,
	"./ics_f_deliveryProcess.svg": 40864,
	"./ics_f_group_two.svg": 50362,
	"./ics_f_info_circle.svg": 31131,
	"./ics_f_location_pin.svg": 44874,
	"./ics_f_location_pin_black.svg": 93505,
	"./ics_f_location_pin_check.svg": 87617,
	"./ics_f_love.svg": 8992,
	"./ics_f_money_alt.svg": 80043,
	"./ics_f_parcel_poin.svg": 42991,
	"./ics_f_phone.svg": 94448,
	"./ics_f_priority_fast.svg": 52356,
	"./ics_f_profile circle.svg": 70344,
	"./ics_f_share.svg": 34827,
	"./ics_f_shield check.svg": 8026,
	"./ics_f_shopping bag.svg": 77645,
	"./ics_f_smartphone.svg": 47092,
	"./ics_f_store.svg": 39927,
	"./ics_f_wallet.svg": 85098,
	"./ics_f_warning_circle.svg": 66109,
	"./ics_f_warning_circle_yellow.svg": 39355,
	"./ics_f_warning_triangles.svg": 64487,
	"./ics_f_warning_triangles_red.svg": 15804,
	"./ics_info_circle": 68916,
	"./ics_info_circle.vue": 68916,
	"./ics_o_arrow_diagonal.svg": 41892,
	"./ics_o_arrow_diagonal_black.svg": 80479,
	"./ics_o_arrow_diagonal_white.svg": 65718,
	"./ics_o_arrow_left_alt_lg.svg": 62657,
	"./ics_o_arrow_right.svg": 5599,
	"./ics_o_arrow_right_alt.svg": 11062,
	"./ics_o_arrow_right_alt_gray.svg": 82514,
	"./ics_o_arrow_right_alt_lg.svg": 42267,
	"./ics_o_arrow_right_black.svg": 7220,
	"./ics_o_attach.svg": 9170,
	"./ics_o_bike": 33679,
	"./ics_o_bike.vue": 33679,
	"./ics_o_box.svg": 35044,
	"./ics_o_box_alt.svg": 77930,
	"./ics_o_calendar.svg": 70955,
	"./ics_o_calendar_grey.svg": 98399,
	"./ics_o_chevron_down.svg": 87365,
	"./ics_o_chevron_down_alt.svg": 87778,
	"./ics_o_chevron_right.svg": 1437,
	"./ics_o_close.svg": 49326,
	"./ics_o_cloud_download.svg": 40603,
	"./ics_o_download.svg": 43592,
	"./ics_o_download_new.svg": 43484,
	"./ics_o_globe": 1622,
	"./ics_o_globe.vue": 1622,
	"./ics_o_info_circle.svg": 10095,
	"./ics_o_location_pin_alt.svg": 39141,
	"./ics_o_maps.svg": 74859,
	"./ics_o_notes": 94241,
	"./ics_o_notes.vue": 94241,
	"./ics_o_payment": 18634,
	"./ics_o_payment.vue": 18634,
	"./ics_o_profile.svg": 69747,
	"./ics_o_question_circle.svg": 48152,
	"./ics_o_search.svg": 70845,
	"./ics_o_search_shade.svg": 63966,
	"./ics_o_sync.svg": 45585,
	"./ics_o_sync_grey.svg": 96537,
	"./ics_o_warning_circle.svg": 321,
	"./ics_o_warning_triangles.svg": 22200,
	"./ics_o_weight": 34864,
	"./ics_o_weight.vue": 34864,
	"./ics_o_whatsapp.svg": 23670,
	"./ics_o_withdraw": 95302,
	"./ics_o_withdraw.vue": 95302,
	"./ics_parcel_poin": 15162,
	"./ics_parcel_poin.vue": 15162,
	"./ics_pencil": 94479,
	"./ics_pencil.vue": 94479,
	"./ics_plus": 89274,
	"./ics_plus.vue": 89274,
	"./ics_question_circle": 50031,
	"./ics_question_circle.vue": 50031,
	"./ics_trash": 44926,
	"./ics_trash.vue": 44926,
	"./ics_warning_circle": 93711,
	"./ics_warning_circle.vue": 93711,
	"./ics_warning_one.png": 45933,
	"./ics_warning_three.png": 7522,
	"./ics_warning_triangles": 73054,
	"./ics_warning_triangles.vue": 73054,
	"./ics_warning_two.png": 88157,
	"./idea_icon.svg": 44993,
	"./ill_merchant_registration.svg": 7598,
	"./ill_merchant_registration_process.svg": 3136,
	"./ill_merchant_registration_process_mobile.svg": 24846,
	"./ill_spot_info.svg": 51702,
	"./ill_spot_miscellaneous.svg": 35896,
	"./ill_spot_paket.svg": 11407,
	"./ill_spot_search.svg": 6161,
	"./img_klaim_approve.svg": 16194,
	"./img_klaim_rejected.svg": 43693,
	"./info-red.svg": 96430,
	"./info.svg": 13759,
	"./informasi-1.jpg": 72702,
	"./informasi-2.jpg": 14463,
	"./informasi-3.jpg": 84636,
	"./informasi-4.jpg": 1054,
	"./information.png": 87278,
	"./information_blue.png": 928,
	"./instagram.png": 18800,
	"./interpack.png": 91496,
	"./interpack_banner_en.png": 96413,
	"./interpack_content_en.svg": 39054,
	"./interpack_content_en_mobile.svg": 67201,
	"./interpack_en.svg": 23593,
	"./invisible.svg": 61424,
	"./jagopack_wrapper3.png": 72041,
	"./kirim_kebaikan_home_banner_desktop.svg": 1531,
	"./kirim_kebaikan_home_banner_mobile.svg": 20167,
	"./klaim/banner_form_claim_mobile.svg": 96022,
	"./klaim/claim-banner-warn-mobile.webp": 52818,
	"./klaim/claim-banner-warn.webp": 36869,
	"./klaim/hero_banner.webp": 66388,
	"./klaim/hero_banner_mobile.webp": 4277,
	"./klaim/step1.svg": 12282,
	"./klaim/step2.svg": 47281,
	"./klaim/step3.svg": 67862,
	"./label-cod-dfod.svg": 88919,
	"./label-cod.svg": 26353,
	"./label-dfod.svg": 81994,
	"./landing_page_merchant.svg": 84422,
	"./landing_page_merchant_mobile.svg": 57817,
	"./landpack.png": 70380,
	"./leaf_about.svg": 64764,
	"./left_leaf.png": 6924,
	"./lilo/bg_lilo_footer.webp": 66102,
	"./lilo/bg_lilo_footer_mobile.webp": 64529,
	"./lilo/bg_lilo_header.webp": 29997,
	"./lilo/bg_lilo_header_mobile.webp": 13822,
	"./lilo/ics_o_coinCOD.svg": 651,
	"./lilo/ics_o_money_alt.svg": 70566,
	"./lilo/ics_o_nearby_shuttle.svg": 39939,
	"./lilo/ics_o_plane.svg": 42325,
	"./lilo/ics_o_profile.svg": 51097,
	"./lilo/ics_o_search.svg": 73354,
	"./lilo/ics_o_shield check.svg": 3221,
	"./lilo/ics_o_thumb-up.svg": 33702,
	"./linked.png": 79199,
	"./lion-parcel-app.webp": 86916,
	"./lion_parcel_logo.png": 69247,
	"./lionparcel.svg": 99886,
	"./locPin.png": 32222,
	"./login_navbar.svg": 84338,
	"./login_navbar_gray_d.svg": 4762,
	"./login_navbar_grey.svg": 56382,
	"./logo-new-red.svg": 69703,
	"./logo-new-white.svg": 70947,
	"./logo-new.svg": 22306,
	"./logo_logout-new.svg": 27529,
	"./logo_oleh_oleh.svg": 67840,
	"./lp_logo_footer.svg": 146,
	"./lp_logo_footer_new.svg": 44156,
	"./lp_logo_red.svg": 37916,
	"./lp_logo_red_new.svg": 46380,
	"./lp_logo_transfarant.svg": 68112,
	"./lp_logo_white.svg": 9463,
	"./mail.png": 94572,
	"./map-pin-maker.svg": 63849,
	"./maps.png": 99373,
	"./membership-sk/avatar1.svg": 13807,
	"./membership-sk/avatar2.svg": 60924,
	"./membership-sk/avatar3.svg": 24416,
	"./membership-sk/avatar4.svg": 33635,
	"./membership-sk/avatar5.svg": 75599,
	"./membership-sk/banner1.svg": 69393,
	"./membership-sk/banner2.svg": 25251,
	"./membership-sk/bg-header-mobile.webp": 78952,
	"./membership-sk/bg-header.webp": 78039,
	"./membership-sk/chevron.svg": 51505,
	"./membership-sk/ill_s&k.svg": 70875,
	"./membership-sk/question.svg": 90076,
	"./merchant/banner-header-desktop.webp": 697,
	"./merchant/banner-header-mobile.webp": 66886,
	"./merchant/bg_merchant_footer.webp": 67509,
	"./merchant/bg_merchant_footer_mobile.webp": 25663,
	"./merchant/bg_merchant_header.webp": 90410,
	"./merchant/bg_merchant_header_mobile.webp": 51096,
	"./merchant/call_merchant.svg": 24706,
	"./merchant/default-product-image.svg": 25603,
	"./merchant/dev-qrcode.png": 46433,
	"./merchant/download-instruction1.svg": 23738,
	"./merchant/download-instruction2.svg": 77891,
	"./merchant/form_merchant_banner_mobile.svg": 15212,
	"./merchant/ill_merchant_registration.svg": 78048,
	"./merchant/ill_merchant_registration_process.svg": 42705,
	"./merchant/ill_merchant_registration_process_mobile.svg": 4694,
	"./merchant/merchant-check.svg": 78229,
	"./merchant/merchant-detail-banner-mobile.svg": 55916,
	"./merchant/merchant-detail-banner.svg": 7118,
	"./merchant/merchant-not-active.svg": 14390,
	"./merchant/prod-qrcode.png": 29614,
	"./merchant/toko1.png": 23862,
	"./merchant/toko2.png": 88035,
	"./merchant/toko3.png": 65813,
	"./merchant/toko4.png": 78282,
	"./merchant/toko5.png": 93312,
	"./min_oleholeh.svg": 7136,
	"./mobile-banner-v2.png": 83981,
	"./mobile_logo.png": 29227,
	"./mobile_logo_three.png": 51707,
	"./mobile_logo_two.png": 34079,
	"./monas_icon.svg": 43627,
	"./money.png": 69135,
	"./my/banner.webp": 38889,
	"./my/banner_mobile.webp": 53870,
	"./my/section-bg.svg": 40606,
	"./new-agent/Frontside.webp": 6592,
	"./new-agent/Inside.webp": 80926,
	"./new-agent/KTP.webp": 43072,
	"./new-agent/benefit1.svg": 4555,
	"./new-agent/benefit2.svg": 5746,
	"./new-agent/benefit3.svg": 71716,
	"./new-agent/benefit4.svg": 78695,
	"./new-agent/benefit5.svg": 83969,
	"./new-agent/benefit6.svg": 262,
	"./new-agent/cash.svg": 55054,
	"./new-agent/database.svg": 97518,
	"./new-agent/desktop-banner-agen-01.webp": 97236,
	"./new-agent/desktop-banner-agen-02.webp": 37977,
	"./new-agent/desktop-banner-agen-03.webp": 40765,
	"./new-agent/desktop-banner-agen-04.webp": 81125,
	"./new-agent/emoji-happy.svg": 56425,
	"./new-agent/map.svg": 10349,
	"./new-agent/mobile-banner-agen-01.webp": 95471,
	"./new-agent/mobile-banner-agen-02.webp": 86502,
	"./new-agent/mobile-banner-agen-03.webp": 18854,
	"./new-agent/mobile-banner-agen-04.webp": 71624,
	"./new-agent/perorangan.svg": 39432,
	"./new-agent/perusahaan.svg": 80321,
	"./new-agent/shopping-bag.svg": 46545,
	"./new-agent/success-bg-desktop.webp": 67991,
	"./new-agent/success-bg-mobile.webp": 6673,
	"./new-agent/user-group.svg": 39591,
	"./new-breadcrumb-home.svg": 16870,
	"./new-dangerous-goods/banner.webp": 50577,
	"./new-dangerous-goods/banner_mobile.webp": 35403,
	"./new-dangerous-goods/bg-DG-Flight.webp": 68767,
	"./new-dangerous-goods/bg-DG-Ship.webp": 74432,
	"./new-dangerous-goods/bg-class1.webp": 14350,
	"./new-dangerous-goods/bg-class2.webp": 62709,
	"./new-dangerous-goods/bg-class3.webp": 81036,
	"./new-dangerous-goods/bg-class4.webp": 81439,
	"./new-dangerous-goods/bg-class5.webp": 43012,
	"./new-dangerous-goods/bg-class6.webp": 61726,
	"./new-dangerous-goods/bg-class7.webp": 58194,
	"./new-dangerous-goods/bg-class8.webp": 43886,
	"./new-dangerous-goods/bg-class9.webp": 38130,
	"./new-dangerous-goods/bg-section-bisadikirim.webp": 72210,
	"./new-dangerous-goods/bg-section-bisidikirim-mobile.webp": 62604,
	"./new-dangerous-goods/bg-section-class-mobile.webp": 9070,
	"./new-dangerous-goods/bg-section-class.webp": 77654,
	"./new-dangerous-goods/bg_bottom.webp": 43427,
	"./new-dangerous-goods/bg_bottom_mobile.webp": 57527,
	"./new-dangerous-goods/bg_classification.svg": 67265,
	"./new-dangerous-goods/bg_sent.svg": 56479,
	"./new-dangerous-goods/class3-step1-mobile.webp": 18697,
	"./new-dangerous-goods/class3-step1.webp": 15919,
	"./new-dangerous-goods/class3-step2-mobile.webp": 79368,
	"./new-dangerous-goods/class3-step2.webp": 22700,
	"./new-dangerous-goods/class3-step3-mobile.webp": 73043,
	"./new-dangerous-goods/class3-step3.webp": 64603,
	"./new-dangerous-goods/class3-step4-mobile.webp": 64702,
	"./new-dangerous-goods/class3-step4.webp": 4441,
	"./new-dangerous-goods/class6-step1-mobile.webp": 57459,
	"./new-dangerous-goods/class6-step1.webp": 16341,
	"./new-dangerous-goods/class6-step2-mobile.webp": 56198,
	"./new-dangerous-goods/class6-step2.webp": 1707,
	"./new-dangerous-goods/class6-step3-mobile.webp": 34618,
	"./new-dangerous-goods/class6-step3.webp": 23458,
	"./new-dangerous-goods/class6-step4-mobile.webp": 31947,
	"./new-dangerous-goods/class6-step4.webp": 23357,
	"./new-dangerous-goods/class9-step1-mobile.webp": 42731,
	"./new-dangerous-goods/class9-step1.webp": 52032,
	"./new-dangerous-goods/class9-step2-mobile.webp": 48440,
	"./new-dangerous-goods/class9-step2.webp": 20574,
	"./new-dangerous-goods/class9-step3-mobile.webp": 74794,
	"./new-dangerous-goods/class9-step3.webp": 72382,
	"./new-dangerous-goods/class9-step4-mobile.webp": 76607,
	"./new-dangerous-goods/class9-step4.webp": 4687,
	"./new-dangerous-goods/icon-info-regulation.svg": 72530,
	"./new-dangerous-goods/icon_dg_class1.svg": 66823,
	"./new-dangerous-goods/icon_dg_class2.svg": 16010,
	"./new-dangerous-goods/icon_dg_class3.svg": 31539,
	"./new-dangerous-goods/icon_dg_class4.svg": 88855,
	"./new-dangerous-goods/icon_dg_class5.svg": 35116,
	"./new-dangerous-goods/icon_dg_class6.svg": 82981,
	"./new-dangerous-goods/icon_dg_class7.svg": 64665,
	"./new-dangerous-goods/icon_dg_class8.svg": 21777,
	"./new-dangerous-goods/icon_dg_class9.svg": 20895,
	"./new-dangerous-goods/ics_f_close_circle.svg": 46889,
	"./new-dangerous-goods/regulation_chip.svg": 46674,
	"./new-dangerous-goods/regulation_plane.svg": 8774,
	"./new-dangerous-goods/regulation_ship.svg": 23286,
	"./new-home/BCA.svg": 74850,
	"./new-home/ThreeBanner-1-mobile.webp": 98418,
	"./new-home/ThreeBanner-1.webp": 70040,
	"./new-home/ThreeBanner-2-mobile.webp": 85820,
	"./new-home/ThreeBanner-2.webp": 54925,
	"./new-home/ThreeBanner-3-mobile.webp": 64065,
	"./new-home/ThreeBanner-3.webp": 71125,
	"./new-home/avoskin.svg": 51766,
	"./new-home/award/2021/desktop/2021-1-desktop.webp": 59785,
	"./new-home/award/2021/desktop/2021-2-desktop.webp": 48248,
	"./new-home/award/2021/desktop/2021-3-desktop.webp": 62686,
	"./new-home/award/2021/mobile/2021-1-mobile.webp": 47441,
	"./new-home/award/2021/mobile/2021-2-mobile.webp": 49053,
	"./new-home/award/2021/mobile/2021-3-mobile.webp": 56953,
	"./new-home/award/2022/desktop/2022-1-desktop.webp": 15348,
	"./new-home/award/2022/desktop/2022-2-desktop.webp": 81143,
	"./new-home/award/2022/desktop/2022-3-desktop.webp": 32805,
	"./new-home/award/2022/desktop/2022-4-desktop.webp": 71147,
	"./new-home/award/2022/desktop/2022-5-desktop.webp": 48375,
	"./new-home/award/2022/desktop/2022-6-desktop.webp": 24643,
	"./new-home/award/2022/desktop/2022-7-desktop.webp": 44987,
	"./new-home/award/2022/desktop/2022-8-desktop.webp": 91644,
	"./new-home/award/2022/mobile/2022-1-mobile.webp": 20327,
	"./new-home/award/2022/mobile/2022-2-mobile.webp": 2063,
	"./new-home/award/2022/mobile/2022-3-mobile.webp": 15068,
	"./new-home/award/2022/mobile/2022-4-mobile.webp": 5624,
	"./new-home/award/2022/mobile/2022-5-mobile.webp": 61279,
	"./new-home/award/2022/mobile/2022-6-mobile.webp": 84116,
	"./new-home/award/2022/mobile/2022-7-mobile.webp": 75552,
	"./new-home/award/2022/mobile/2022-8-mobile.webp": 24726,
	"./new-home/award/2023/desktop/2023-1-desktop.webp": 42626,
	"./new-home/award/2023/desktop/2023-10-desktop.webp": 9345,
	"./new-home/award/2023/desktop/2023-11-desktop.webp": 78059,
	"./new-home/award/2023/desktop/2023-12-desktop.webp": 94495,
	"./new-home/award/2023/desktop/2023-13-desktop.webp": 68729,
	"./new-home/award/2023/desktop/2023-14-desktop.webp": 87339,
	"./new-home/award/2023/desktop/2023-15-desktop.webp": 23618,
	"./new-home/award/2023/desktop/2023-2-desktop.webp": 35542,
	"./new-home/award/2023/desktop/2023-3-desktop.webp": 89763,
	"./new-home/award/2023/desktop/2023-4-desktop.webp": 49758,
	"./new-home/award/2023/desktop/2023-5-desktop.webp": 89939,
	"./new-home/award/2023/desktop/2023-6-desktop.webp": 79286,
	"./new-home/award/2023/desktop/2023-7-desktop.webp": 9076,
	"./new-home/award/2023/desktop/2023-8-desktop.webp": 81211,
	"./new-home/award/2023/desktop/2023-9-desktop.webp": 44067,
	"./new-home/award/2023/mobile/2023-1-mobile.webp": 4778,
	"./new-home/award/2023/mobile/2023-10-mobile.webp": 92403,
	"./new-home/award/2023/mobile/2023-11-mobile.webp": 45914,
	"./new-home/award/2023/mobile/2023-12-mobile.webp": 21823,
	"./new-home/award/2023/mobile/2023-13-mobile.webp": 7562,
	"./new-home/award/2023/mobile/2023-14-mobile.webp": 48388,
	"./new-home/award/2023/mobile/2023-15-mobile.webp": 35544,
	"./new-home/award/2023/mobile/2023-2-mobile.webp": 73104,
	"./new-home/award/2023/mobile/2023-3-mobile.webp": 35792,
	"./new-home/award/2023/mobile/2023-4-mobile.webp": 46416,
	"./new-home/award/2023/mobile/2023-5-mobile.webp": 68342,
	"./new-home/award/2023/mobile/2023-6-mobile.webp": 39932,
	"./new-home/award/2023/mobile/2023-7-mobile.webp": 99566,
	"./new-home/award/2023/mobile/2023-8-mobile.webp": 68431,
	"./new-home/award/2023/mobile/2023-9-mobile.webp": 77241,
	"./new-home/award/2024/desktop/2024-1-desktop.webp": 99733,
	"./new-home/award/2024/desktop/2024-2-desktop.webp": 33872,
	"./new-home/award/2024/desktop/2024-3-desktop.webp": 61347,
	"./new-home/award/2024/desktop/2024-4-desktop.webp": 55934,
	"./new-home/award/2024/desktop/2024-5-desktop.webp": 38943,
	"./new-home/award/2024/desktop/2024-6-desktop.webp": 19744,
	"./new-home/award/2024/desktop/2024-7-desktop.webp": 79568,
	"./new-home/award/2024/desktop/2024-8-desktop.webp": 63359,
	"./new-home/award/2024/desktop/2024-9-desktop.webp": 99391,
	"./new-home/award/2024/mobile/2024-1-mobile.webp": 77383,
	"./new-home/award/2024/mobile/2024-2-mobile.webp": 61396,
	"./new-home/award/2024/mobile/2024-3-mobile.webp": 93249,
	"./new-home/award/2024/mobile/2024-4-mobile.webp": 2984,
	"./new-home/award/2024/mobile/2024-5-mobile.webp": 84785,
	"./new-home/award/2024/mobile/2024-6-mobile.webp": 90363,
	"./new-home/award/2024/mobile/2024-7-mobile.webp": 13777,
	"./new-home/award/2024/mobile/2024-8-mobile.webp": 66594,
	"./new-home/award/2024/mobile/2024-9-mobile.webp": 14642,
	"./new-home/award/2025/desktop/2025-1-desktop.webp": 18831,
	"./new-home/award/2025/mobile/2025-1-mobile.webp": 70745,
	"./new-home/award/award-bg.webp": 29932,
	"./new-home/bg-bottom-section-mobile.png": 6707,
	"./new-home/bg-bottom-section.png": 88428,
	"./new-home/blibli.svg": 21189,
	"./new-home/download-app/download-app-banner-desktop.png": 89430,
	"./new-home/download-app/download-app-banner-desktop.webp": 16207,
	"./new-home/download-app/download-app-banner-mobile.webp": 81527,
	"./new-home/download-app/pickup-icon.svg": 80313,
	"./new-home/download-app/point-icon.png": 29105,
	"./new-home/download-app/point-icon.svg": 51952,
	"./new-home/download-app/price-icon.svg": 21510,
	"./new-home/download-app/report-icon.svg": 16188,
	"./new-home/ics_o_pasti.svg": 39442,
	"./new-home/ikea.svg": 13967,
	"./new-home/info-slider-1-mobile.webp": 26472,
	"./new-home/info-slider-1.webp": 26343,
	"./new-home/info-slider-2-mobile.webp": 97555,
	"./new-home/info-slider-2.webp": 56416,
	"./new-home/info-slider-3-mobile.webp": 62793,
	"./new-home/info-slider-3.webp": 48111,
	"./new-home/info-slider-4-mobile.webp": 17251,
	"./new-home/info-slider-4.webp": 89326,
	"./new-home/samsung.svg": 72958,
	"./new-home/sinarmas.svg": 84535,
	"./new-home/tokopedia.svg": 43419,
	"./new_ribbon.svg": 51627,
	"./new_tag_poppins.svg": 93560,
	"./no_merchant.svg": 56747,
	"./normal_emot.svg": 39256,
	"./not_found.svg": 83537,
	"./office.png": 63200,
	"./onepack.png": 2137,
	"./oops.svg": 5953,
	"./order/1.svg": 59060,
	"./order/2.svg": 42197,
	"./order/3.svg": 19250,
	"./order/4.svg": 23563,
	"./order/5.svg": 55713,
	"./order/6.svg": 77577,
	"./order/billIcon": 59550,
	"./order/billIcon.vue": 59550,
	"./order/checkIcon": 59497,
	"./order/checkIcon.vue": 59497,
	"./order/closeIcon": 64673,
	"./order/closeIcon.vue": 64673,
	"./order/deliveryIcon": 64807,
	"./order/deliveryIcon.vue": 64807,
	"./order/dropoffServiceIcon.svg": 44158,
	"./order/ics_f_announce.svg": 79141,
	"./order/ics_f_check_circle.svg": 18478,
	"./order/ics_f_clock.svg": 56682,
	"./order/ics_f_coin.svg": 34337,
	"./order/ics_f_fragile.svg": 61183,
	"./order/ics_f_plus_circle.svg": 83800,
	"./order/ics_f_star.svg": 30000,
	"./order/ics_o_check.svg": 34657,
	"./order/ics_o_close.svg": 2380,
	"./order/ics_o_insurance.svg": 18731,
	"./order/ill_agent.svg": 74964,
	"./order/ill_boost.svg": 31238,
	"./order/ill_download_barcode.svg": 72038,
	"./order/ill_parcel_point_membership.svg": 52627,
	"./order/ill_spot_boost.svg": 41360,
	"./order/marker_map.svg": 32903,
	"./order/onDeliveryIcon": 95570,
	"./order/onDeliveryIcon.vue": 95570,
	"./order/pickupServiceIcon.svg": 67908,
	"./order/recomendation.svg": 33320,
	"./ornament.svg": 2139,
	"./phone.png": 82364,
	"./plane-lion-air.svg": 12698,
	"./playStore.svg": 42073,
	"./playstore-plain.svg": 43669,
	"./playstore.png": 29274,
	"./playstore.webp": 49651,
	"./plus_circle.png": 42337,
	"./process_claim.png": 22514,
	"./process_track.png": 99743,
	"./product-new_bigpack.svg": 13347,
	"./product-new_docupack.svg": 67652,
	"./product-new_interpack.svg": 42599,
	"./product-new_jagopack.svg": 60645,
	"./product-new_onepack.svg": 86491,
	"./product-new_regpack.svg": 13593,
	"./product/banner.webp": 42294,
	"./product/banner_mobile.webp": 63784,
	"./product_empty.svg": 63231,
	"./product_interpack.svg": 80771,
	"./product_interpack1.svg": 28097,
	"./product_interpack_mobile.svg": 4210,
	"./product_landpack.svg": 69809,
	"./product_landpack1.svg": 82525,
	"./product_landpack_mobile.svg": 36208,
	"./product_onepack.svg": 77760,
	"./product_onepack1.svg": 30083,
	"./product_onepack_mobile.svg": 37280,
	"./product_onepack_questionmark.svg": 8454,
	"./product_questionmark.svg": 67787,
	"./product_regpack.svg": 69576,
	"./product_regpack1.svg": 22821,
	"./product_regpack_mobile.svg": 60557,
	"./program_mobile.png": 13578,
	"./promo/banner.webp": 51051,
	"./promo/banner_mobile.webp": 20716,
	"./promo/img.png": 52685,
	"./promo/program-banner.png": 76613,
	"./promo_shok.png": 55676,
	"./purple_leaf.png": 98630,
	"./quarantine/bg_quarantine_footer.webp": 25400,
	"./quarantine/bg_quarantine_footer_mobile.webp": 42156,
	"./quarantine/bg_quarantine_footer_mobile_red.webp": 14304,
	"./quarantine/bg_quarantine_footer_red.webp": 53951,
	"./quarantine/bg_quarantine_header.webp": 36935,
	"./quarantine/bg_quarantine_header_mobile.webp": 83161,
	"./quarantine/box.webp": 68210,
	"./quarantine/ics_f_chat_question.svg": 97000,
	"./quarantine/ics_f_chat_question_red.svg": 97510,
	"./quarantine/ics_f_cherry.svg": 90976,
	"./quarantine/ics_f_file.svg": 37151,
	"./quarantine/ics_f_file_red.svg": 95450,
	"./quarantine/ics_f_money_alt.svg": 31533,
	"./quarantine/ics_f_money_alt_red.svg": 35188,
	"./quarantine/ics_f_reconcile_red.svg": 92067,
	"./quarantine/ill_top.svg": 52504,
	"./quarantine/quarantine_sub.webp": 40438,
	"./quarantine/quarantine_sub_mobile.webp": 84998,
	"./quarantine/quarantine_sub_mobile_red.webp": 7349,
	"./quarantine/quarantine_sub_red.webp": 17653,
	"./question.png": 51661,
	"./red_leaf.png": 28709,
	"./red_leaf_.png": 27283,
	"./red_lock.svg": 60421,
	"./register_agent.png": 16018,
	"./regpack.png": 49825,
	"./ribbon_app_web.svg": 58515,
	"./ribbon_cod.svg": 19657,
	"./ribbon_mbg_detail_tarif.png": 20005,
	"./ribbon_new_detail_tarif.png": 9909,
	"./ribbon_promo.png": 60456,
	"./right_leaf.png": 5595,
	"./right_leaf.svg": 66054,
	"./run_icon.svg": 9869,
	"./sad_emot.svg": 18908,
	"./saldo_point_icon.svg": 14815,
	"./saldo_point_warning_icon.svg": 27326,
	"./second_red_leaf.png": 58395,
	"./secondcloud.png": 82184,
	"./sended.svg": 59029,
	"./service_icon.svg": 16770,
	"./slider-black-left.svg": 55385,
	"./slider-black-right.svg": 80893,
	"./slider-blackWithRoundM-left.svg": 2728,
	"./slider-blackWithRoundM-right.svg": 95540,
	"./slider-red-left.svg": 88456,
	"./slider-red-right.svg": 27338,
	"./slider-redWithRound-left.svg": 31267,
	"./slider-redWithRound-right.svg": 18680,
	"./slider-redWithRoundM-left.svg": 74182,
	"./slider-redWithRoundM-right.svg": 80001,
	"./slider-whiteWithRoundBlackM-left.svg": 65065,
	"./slider-whiteWithRoundBlackM-right.svg": 8150,
	"./sm_facebook.svg": 43740,
	"./sm_insta.svg": 3079,
	"./sm_linkedin.svg": 17611,
	"./sm_tiktok.svg": 77809,
	"./sm_twitter.svg": 9956,
	"./sm_youtube.svg": 1268,
	"./step_agent.png": 66459,
	"./step_one_claim.svg": 34352,
	"./step_success_agent.png": 86674,
	"./step_three_claim.svg": 89737,
	"./step_two_claim.svg": 97310,
	"./store.png": 82064,
	"./store_blue.png": 27842,
	"./subtract.png": 17168,
	"./subtract_left.png": 27881,
	"./subtract_right.png": 68284,
	"./success-bg-desktop.webp": 82381,
	"./success-bg-mobile.webp": 42424,
	"./success-register-revamp.svg": 28857,
	"./success-register.svg": 37116,
	"./success_illustration.svg": 59723,
	"./success_register_agent.png": 97913,
	"./sun.png": 88226,
	"./suncloud.png": 22316,
	"./tarif_bigpack.png": 81025,
	"./tarif_docupack.png": 9444,
	"./tarif_interpack.png": 93226,
	"./tarif_jagopack.png": 77596,
	"./tarif_onepack.png": 29500,
	"./tarif_regpack.png": 96252,
	"./tariff/alert.svg": 97861,
	"./tariff/banner.webp": 14145,
	"./tariff/banner_mobile.webp": 93772,
	"./tariff/banner_sm.svg": 79211,
	"./tariff/banner_xl.svg": 51385,
	"./tariff/download-instruction1.svg": 62578,
	"./tariff/download-instruction2.svg": 65776,
	"./tariff/info.svg": 10483,
	"./tariff/no_tariff.svg": 1749,
	"./tariff/prod-qrcode.png": 64610,
	"./tariff/promo_aplikasi.svg": 80227,
	"./tariff/promo_aplikasi_gray.svg": 20751,
	"./tariff/promo_app_vector.svg": 3744,
	"./terms-and-conditions/referral-progam-1.svg": 93770,
	"./terms-and-conditions/referral-progam-2.svg": 85811,
	"./terms-and-conditions/referral-progam-3.svg": 25501,
	"./terms-and-conditions/referral-progam-4.svg": 48055,
	"./thirdcloud.png": 78759,
	"./tiktok.png": 84663,
	"./token_expired.svg": 55290,
	"./track-agent/banner.webp": 82878,
	"./track-agent/banner_mobile.webp": 84256,
	"./track-agent/ill_empty_search.svg": 14491,
	"./track-agent/ill_oops.svg": 43924,
	"./tracking/bannerMY.webp": 3486,
	"./tracking/banner_mobileMY.webp": 22725,
	"./tracking/chevron.svg": 98017,
	"./tracking/cod.svg": 45236,
	"./tracking/dfod.svg": 79847,
	"./tracking/disable_admin-cancel-payment.svg": 96571,
	"./tracking/disable_admin-cancel.svg": 55226,
	"./tracking/disable_approved_claim_icon.svg": 36946,
	"./tracking/disable_at-destination.svg": 29316,
	"./tracking/disable_cargo.svg": 39227,
	"./tracking/disable_checked.svg": 36812,
	"./tracking/disable_checking.svg": 34284,
	"./tracking/disable_closed_claim_icon.svg": 67528,
	"./tracking/disable_create-dropoff.svg": 7622,
	"./tracking/disable_customer-cancel.svg": 28726,
	"./tracking/disable_default.svg": 38389,
	"./tracking/disable_driver-cancel.svg": 10240,
	"./tracking/disable_driver-done-hub.svg": 81175,
	"./tracking/disable_driver-near.svg": 10327,
	"./tracking/disable_driver-not-found.svg": 8214,
	"./tracking/disable_driver-pickup.svg": 53260,
	"./tracking/disable_failed.svg": 2647,
	"./tracking/disable_find-driver.svg": 79346,
	"./tracking/disable_in-transit.svg": 18609,
	"./tracking/disable_misbooking.svg": 97968,
	"./tracking/disable_new-on-process.svg": 58421,
	"./tracking/disable_new_claim_icon.svg": 68110,
	"./tracking/disable_occ.svg": 65337,
	"./tracking/disable_on-process.svg": 58792,
	"./tracking/disable_onprogress_claim_icon.svg": 54108,
	"./tracking/disable_paid_claim_icon.svg": 48689,
	"./tracking/disable_pending_claim_icon.svg": 93092,
	"./tracking/disable_pod.svg": 14945,
	"./tracking/disable_queue-driver.svg": 11675,
	"./tracking/disable_rejected_claim_icon.svg": 8051,
	"./tracking/disable_reroute.svg": 7641,
	"./tracking/disable_return.svg": 24377,
	"./tracking/disable_schedule-pickup.svg": 38911,
	"./tracking/disable_search.svg": 22487,
	"./tracking/disable_ship.svg": 3825,
	"./tracking/disable_shipment-create.svg": 2401,
	"./tracking/disable_system-cancel.svg": 69253,
	"./tracking/disable_train.svg": 59113,
	"./tracking/disable_transit.svg": 66383,
	"./tracking/disable_truck.svg": 11315,
	"./tracking/disable_warehouse-destination.svg": 55703,
	"./tracking/disable_with-courier.svg": 61079,
	"./tracking/disable_x.svg": 15939,
	"./tracking/drop-down.svg": 77412,
	"./tracking/enable_admin-cancel-payment.svg": 16952,
	"./tracking/enable_admin-cancel.svg": 99429,
	"./tracking/enable_approved_claim_icon.svg": 53729,
	"./tracking/enable_at-destination.svg": 56218,
	"./tracking/enable_cargo.svg": 98071,
	"./tracking/enable_checked.svg": 96202,
	"./tracking/enable_checking.svg": 69948,
	"./tracking/enable_closed_claim_icon.svg": 41281,
	"./tracking/enable_create-dropoff.svg": 24329,
	"./tracking/enable_customer-cancel.svg": 13343,
	"./tracking/enable_default.svg": 14689,
	"./tracking/enable_driver-cancel.svg": 40591,
	"./tracking/enable_driver-done-hub.svg": 36447,
	"./tracking/enable_driver-near.svg": 46803,
	"./tracking/enable_driver-not-found.svg": 66335,
	"./tracking/enable_driver-pickup.svg": 31211,
	"./tracking/enable_failed.svg": 86701,
	"./tracking/enable_find-driver.svg": 79573,
	"./tracking/enable_in-transit.svg": 93714,
	"./tracking/enable_misbooking.svg": 99346,
	"./tracking/enable_new-on-process.svg": 7337,
	"./tracking/enable_new_claim_icon.svg": 75030,
	"./tracking/enable_occ.svg": 86834,
	"./tracking/enable_on-process.svg": 63979,
	"./tracking/enable_onprogress_claim_icon.svg": 89578,
	"./tracking/enable_paid_claim_icon.svg": 64970,
	"./tracking/enable_pending_claim_icon.svg": 7044,
	"./tracking/enable_pod.svg": 48105,
	"./tracking/enable_queue-driver.svg": 88028,
	"./tracking/enable_rejected_claim_icon.svg": 90806,
	"./tracking/enable_reroute.svg": 62520,
	"./tracking/enable_return.svg": 31444,
	"./tracking/enable_schedule-pickup.svg": 48835,
	"./tracking/enable_search.svg": 43128,
	"./tracking/enable_ship.svg": 24718,
	"./tracking/enable_shipment-create.svg": 37581,
	"./tracking/enable_system-cancel.svg": 85165,
	"./tracking/enable_train.svg": 60501,
	"./tracking/enable_transit.svg": 83102,
	"./tracking/enable_truck.svg": 75061,
	"./tracking/enable_warehouse-destination.svg": 62872,
	"./tracking/enable_with-courier.svg": 57829,
	"./tracking/enable_x.svg": 7269,
	"./tracking/track_banner.svg": 63810,
	"./tracking/track_banner.webp": 58497,
	"./tracking/track_banner_mobile.svg": 29574,
	"./tracking/track_banner_mobile.webp": 24374,
	"./tracking/track_canceled.svg": 34952,
	"./tracking/track_in-process.svg": 68006,
	"./tracking/track_result_tokopedia.svg": 71366,
	"./tracking/track_unavailable.svg": 57436,
	"./trashIcon.svg": 97679,
	"./trees_red.png": 2674,
	"./trees_red_small.png": 11277,
	"./truck.png": 10638,
	"./twitter.png": 22519,
	"./umkm_card.svg": 35572,
	"./umkm_source_card.svg": 1777,
	"./umkm_webinar_card.svg": 22396,
	"./union.svg": 35958,
	"./up_logo.svg": 92070,
	"./uploads.png": 28029,
	"./wa_small.png": 12375,
	"./wa_small_new.svg": 12688,
	"./wa_wide.png": 8132,
	"./wa_wide_new.svg": 99065,
	"./warning.svg": 70019,
	"./web-header-agent-mobile.svg": 36376,
	"./web-header-agent.svg": 34524,
	"./whatsapp.png": 42141,
	"./why_us_1.svg": 76223,
	"./why_us_2.svg": 2846,
	"./why_us_3.svg": 76884,
	"./why_us_4.svg": 78047,
	"./www.png": 30071,
	"./x.svg": 81112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;